(function () {
  if (window.customProductSwitcherInitialized) return;
  window.customProductSwitcherInitialized = true;

  function getSectionElement(element) {
    return element.closest('[id^="shopify-section-"]');
  }

  function isSameUrl(url) {
    try {
      const target = new URL(url, window.location.origin);
      return target.pathname === window.location.pathname;
    } catch (e) {
      return false;
    }
  }

  async function silentReload(triggerElement, url) {
    const currentSection = getSectionElement(triggerElement);

    if (!currentSection) {
      window.location.assign(url);
      return;
    }

    const currentSectionId = currentSection.id;

    try {
      currentSection.classList.add('is-loading');

      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!res.ok) {
        throw new Error(`Product fetch failed: ${res.status}`);
      }

      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newSection = doc.getElementById(currentSectionId);

      if (!newSection) {
        window.location.assign(url);
        return;
      }

      currentSection.replaceWith(newSection);
      window.history.pushState({}, '', url);

      document.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          detail: {
            sectionId: currentSectionId.replace('shopify-section-', '')
          }
        })
      );

      initCustomProductSwitcher(document);
    } catch (err) {
      console.error('[CUSTOM PRODUCT SWITCHER] Silent reload failed:', err);
      window.location.assign(url);
    }
  }

  function bindLinks(wrapper) {
    if (!wrapper || wrapper.dataset.ready === 'true') return;
    wrapper.dataset.ready = 'true';

    wrapper.addEventListener('click', function (event) {
      const link = event.target.closest('[data-product-switch-link]');
      if (!link) return;

      const targetUrl = link.getAttribute('href');

      if (!targetUrl || isSameUrl(targetUrl)) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      silentReload(wrapper, targetUrl);
    });
  }

  function bindSelect(wrapper) {
    if (!wrapper || wrapper.dataset.ready === 'true') return;
    wrapper.dataset.ready = 'true';

    wrapper.addEventListener('change', function (event) {
      const select = event.target.closest('[data-product-switch-select]');
      if (!select) return;

      const targetUrl = select.value;

      if (!targetUrl || isSameUrl(targetUrl)) return;

      silentReload(wrapper, targetUrl);
    });
  }

  function initCustomProductSwitcher(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-custom-product-switcher-links]').forEach(function (wrapper) {
      bindLinks(wrapper);
    });

    scope.querySelectorAll('[data-custom-product-switcher-select]').forEach(function (wrapper) {
      bindSelect(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCustomProductSwitcher(document);
  });

  document.addEventListener('shopify:section:load', function () {
    initCustomProductSwitcher(document);
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();